<template>
    <div>
        <h1 class="text-center mt-4 d-none d-lg-block"> Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de Fysson
        </h1>
        <h4 class="text-center mt-4 d-lg-none">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de Fysson
        </h4>
        <div class="card mt-lg-5 mt-3">
            <div class="card-header text-center bg-custom text-white h5">
                <b-icon icon="info-circle"></b-icon>
                Ponemos a su disposici&oacute;n nuestro portal en l&iacute;nea para agilizar el proceso de facturaci&oacute;n
            </div>
            <div class="card-body px-md-5 py-4">
                <p class="card-text text-center"><b>
                    ¡Bienvenidos al portal de <span style="color: #f18524;">facturaci&oacute;n electr&oacute;nica</span> de Fysson!<br>
                    Solo necesitan ingresar los datos de su compra y en pocos pasos obtendr&aacute;s tu factura. 
                    Nuestro sitio est&aacute; diseñado para brindarte una experiencia &aacute;gil y segura, cumpliendo con los requisitos del SAT. <br><br>
                    Será necesario que los siguientes datos y condiciones sean fieles a su Constancia de Situaci&oacute;n Fiscal actual:
                </b></p>
                <ul class="list-unstyled">
                    <li><span style="color: #fff; background-color: #f18524; border-radius: 20px; padding: 2px 4px; ">&#10003;</span> RFC.</li>
                    <li><span style="color: #fff; background-color: #f18524; border-radius: 20px; padding: 2px 4px; ">&#10003;</span> Raz&oacute;n Social.</li>
                    <li><span style="color: #fff; background-color: #f18524; border-radius: 20px; padding: 2px 4px; ">&#10003;</span> Domicilio.</li>
                    <li><span style="color: #fff; background-color: #f18524; border-radius: 20px; padding: 2px 4px; ">&#10003;</span> C&oacute;digo postal.</li>
                    <li><span style="color: #fff; background-color: #f18524; border-radius: 20px; padding: 2px 4px; ">&#10003;</span> R&eacute;gimen Fiscal.</li>
                </ul>
                <p class="card-text text-center">
                    As&iacute; mismo le informamos que: <br>
                    El plazo para  la emisi&oacute;n de su factura ser&aacute; a mas tardar  el decimo d&iacute;a natural del mes siguiente al que realiz&oacute; su compra. <br>
                    El servicio de facturaci&oacute;n solo permite una factura por nota de venta. <br>
                    Le sugerimos revisar que la informaci&oacute;n ingresada sea la correcta. <br>
                    En caso de correcciones  o modificaciones  tiene que comunicarse a la sucursal donde  realiz&oacute; su compra. 
                </p>
                <router-link tag="a" :to="{ name: 'Invoice' }" class="btn btn-custom">
                    <b>Facturar</b>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartAhued',
    }
    
</script>

